import React from 'react';
import toast, { Toaster } from 'react-hot-toast';
import * as Utils from "../../inc/Utils";

import {confirmAlert} from "react-confirm-alert";
import Role from "../../inc/Role";
import {NavLink, useNavigate} from "react-router-dom";
import * as Icon from "react-bootstrap-icons";
import {Config} from '../../Config'
import DatePicker from "react-datepicker";
import Select from 'react-select'
import moment from "moment-timezone";
import {getOwnerRunningId} from "../../inc/Utils";
import {getOwnerRunningCode} from "../../inc/Utils";

export default function UtmGenerateMultiple() {
    const roles = new Role();
    let userId = roles.loginUserId;

    let btnTextDefault = 'บันทึกข้อมูล';
    let btnTextLoading = 'กำลังบันทึก..';
    let [isLoading, setLoading] = React.useState(false);
    let [type, setType] = React.useState('');
    let [lang, setLanguage] = React.useState('');
    let [projectType, setProjectType] = React.useState('');
    let [project, setProject] = React.useState('');
    let [campaign, setCampaign] = React.useState('');
    let [campaignType, setCampaignType] = React.useState(null);
    let [buType, setBuType] = React.useState(null);
    let [promotion, setPromotion] = React.useState('');
    let [utmTemplate, setUtmTemplate] = React.useState(null);
    let [utmGroup, setUtmGroup] = React.useState(null);
    let [utmGroupItem, setUtmGroupItem] = React.useState(null);
    let [rebrandly, setRebrandly] = React.useState(null);
    let [shortio, setShortIO] = React.useState(null);
    const navigate = useNavigate();

    let [campaignDate, setCampaignDate] = React.useState(''); 
    let [typeId, setTypeId] = React.useState(null);
    let [projectTypeId, setProjectTypeId] = React.useState(null);
    let [projectId, setProjectId] = React.useState(null);
    let [campaignId, setCampaignId] = React.useState(null);
    let [campaignTypeId, setCampaignTypeId] = React.useState(null);
    let [buTypeId, setBuTypeId] = React.useState(null);
    let [promotionId, setPromotionId] = React.useState(null);
    let [utmTemplateId, setUtmTemplateId] = React.useState(null);
    let [utmGroupId, setUtmGroupId] = React.useState(null);
    let [utmGroupItemId, setUtmGroupItemId] = React.useState(null);
    let [langId, setLanguageId] = React.useState(null);
    let [projectPlaceholder, setProjectPlaceholder] = React.useState('...');
    let [campaignPlaceholder, setCampaignPlaceholder] = React.useState('...');
    let [promotionPlaceholder, setPromotionPlaceholder] = React.useState('...');
    let [disableProject, setDisableProject] = React.useState(true);
    let [disableCampaign, setDisableCampaign] = React.useState(true);
    let [disablePromotion, setDisablePromotion] = React.useState(true);
    let [disableGroup, setDisableGroup] = React.useState(true);
    let [hashtagList, setHashtagList] = React.useState('');
    let [hashtag, setHashtag] = React.useState(null);

    let [disableMasterUrl, setDisableMasterUrl] = React.useState(true);
    let [masterUrlPlaceholder, setMasterUrlPlaceholder] = React.useState('...');
    let [masterUrl, setMasterUrl] = React.useState(null);
    let [masterUrlId, setMasterUrlId] = React.useState(null);
    let [masterUrlText, setMasterUrlText] = React.useState(null);

    let [showProjectMasterURL, setShowProjectMasterURL] = React.useState(false);
    let [projectMasterURL, setProjectMasterURL] = React.useState('');
    let [projectMasterURLPlaceholder, setProjectMasterURLPlaceholder] = React.useState('...');
    let [disableProjectMasterURL, setDisableProjectMasterURL] = React.useState(true);
    let [userAgency, setUserAgency] = React.useState(null);

    let refUrl = React.useRef();
    React.useEffect(() => {
        (async function() {
            try {
                const resType = await Utils.getType();
                setType(resType);
                const resLanguage = await Utils.getLanguage();
                setLanguage(resLanguage);
                const resProjectType = await Utils.getProjectType();
                setProjectType(resProjectType);
                const resCampaignType = await Utils.getCampaignType();
                setCampaignType(resCampaignType);
                const resBuType = await Utils.getBuType();
                setBuType(resBuType);
                const resTemplate = await Utils.getTemplate({agencyId: roles.permissionId === Utils.SUPER_ADMIN_ID ? null : roles.agencyId});
                setUtmTemplate(resTemplate);
                const resRebrandly = await Utils.getRebrandly();
                setRebrandly(resRebrandly);
                const resShortIO = await Utils.getShortIO();
                setShortIO(resShortIO);
                const resHashtag = await Utils.getHashtag();
                setHashtagList(resHashtag);

                const resAgency = await Utils.getAgency({agencyId: roles.agencyId});
                if(resAgency) {
                    setUserAgency(resAgency[0]);
                }

                //Get Project / Campaign
                if(typeId && (typeId.id === Utils.GENERATE_TYPE_PROJECT) && langId && langId.id && projectTypeId && projectTypeId.id) {
                    setProjectPlaceholder('กำลังโหลด...');
                    const proj = await Utils.getProjectCode(langId.id, projectTypeId.id);
                    if(proj.data) {
                        setProject(proj.data);
                        setProjectPlaceholder('Select...');
                        setDisableProject(false);
                    }
                    else {
                        setProject(null);
                        setProjectPlaceholder('ไม่พบข้อมูล..');
                    }

                    if(projectId && projectId.project_code) {
                        setCampaignPlaceholder('กำลังโหลด...');
                        const camp = await Utils.getCampaign({
                            langId: langId.id,
                            projectType: projectTypeId.id,
                            projectCode: projectId.project_code,
                            campaignDate: campaignDate
                        });
                        let campaignList = [];
                        campaignList.push({
                            campaign_id: '0638A01',
                            campaign_name: 'NonDefine'
                        });
                        if(camp && camp.data) {
                            if(camp.data[0].promotions) {
                                for(let rs of camp.data[0].promotions) {
                                    campaignList.push({
                                        campaign_id: rs.campaign_id,
                                        campaign_name: rs.campaign_name
                                    });
                                }
                            }
                            setCampaignPlaceholder('Select...');
                        }
                        else {
                            setCampaignId(campaignList[0]);
                        }
                        setCampaign(campaignList);
                        setDisableCampaign(false);
                    }
                }
                //Get Promotion
                if(typeId && (typeId.id === Utils.GENERATE_TYPE_PROMOTION) && langId && langId.id && campaignTypeId && campaignTypeId.id && buTypeId && buTypeId.id) {
                    setPromotionPlaceholder('กำลังโหลด...');
                    const prom = await Utils.getPromotion({
                        langId: langId.id,
                        campaignTypeId: campaignTypeId.id,
                        buTypeId: buTypeId.id,
                        campaignDate: campaignDate,
                        campaignId: campaignId ? campaignId.id : ''
                    });
                    if(prom.data) {
                        setPromotion(prom.data);
                        setPromotionPlaceholder('Select...');
                        setDisablePromotion(false);
                    }
                    else {
                        setPromotion(null);
                        setPromotionPlaceholder('ไม่พบข้อมูล..');
                    }
                }

                if(typeId && (typeId.id === Utils.GENERATE_TYPE_MASTER_URL) && langId && langId.id && projectTypeId && projectTypeId.id && showProjectMasterURL) {
                    setProjectMasterURLPlaceholder('กำลังโหลด...');
                    const proj = await Utils.getProjectCode(langId.id, projectTypeId.id);
                    if(proj.data) {
                        setProjectMasterURL(proj.data);
                        setProjectMasterURLPlaceholder('Select...');
                        setDisableProjectMasterURL(false);
                    }
                    else {
                        setProjectMasterURL(null);
                        setProjectMasterURLPlaceholder('ไม่พบข้อมูล..');
                    }
                }

            } catch (e) {
                toast.error(e.message);
            }
        })();
    }, [langId, projectTypeId, projectId, campaignDate, campaignTypeId, buTypeId]);

    const onCreate = async () => {
        if(!typeId) {
            toast.error("กรุณาระบุ Type");
        }
        else if(typeId && (typeId.id === Utils.GENERATE_TYPE_PROJECT || typeId.id === Utils.GENERATE_TYPE_PROMOTION) && !langId) {
            toast.error("กรุณาระบุ Language");
        }
        else if(typeId && (typeId.id === Utils.GENERATE_TYPE_PROJECT) && !projectTypeId) {
            toast.error("กรุณาระบุ Project Type");
        }
        else if(typeId && (typeId.id === Utils.GENERATE_TYPE_PROJECT) && !projectId) {
            toast.error("กรุณาระบุ Project");
        }
        else if(typeId && (typeId.id === Utils.GENERATE_TYPE_PROMOTION) && !campaignTypeId) {
            toast.error("กรุณาระบุ Campaign Type");
        }
        else if(typeId && (typeId.id === Utils.GENERATE_TYPE_PROMOTION) && !buTypeId) {
            toast.error("กรุณาระบุ BU Type");
        }
        else if(typeId && (typeId.id === Utils.GENERATE_TYPE_MASTER_URL) && !masterUrlId) {
            toast.error("กรุณาระบุ Master URL");
        }
        else if(typeId && (typeId.id === Utils.GENERATE_TYPE_PROJECT || typeId.id === Utils.GENERATE_TYPE_SPECIAL || typeId.id === Utils.GENERATE_TYPE_MASTER_URL) && !campaignId) {
           toast.error("กรุณาระบุ Campaign ID");
        }
        else if(typeId && (typeId.id === Utils.GENERATE_TYPE_PROMOTION) && !promotionId) {
            toast.error("กรุณาระบุ Promotion ID");
        }
        else if(typeId && (typeId.id !== Utils.GENERATE_TYPE_MASTER_URL) && !refUrl.current.value) {
            toast.error("กรุณาระบุ URL");
            refUrl.current.focus();
        }
        else if(!utmTemplateId) {
            toast.error("กรุณาระบุ Template");
        }
        else if(typeId && ((typeId.id === Utils.GENERATE_TYPE_MASTER_URL && showProjectMasterURL) || typeId.id === Utils.GENERATE_TYPE_PROMOTION) && !langId) {
            toast.error("กรุณาระบุ Language");
        }
        else if(typeId && (typeId.id === Utils.GENERATE_TYPE_MASTER_URL && showProjectMasterURL) && !projectTypeId) {
            toast.error("กรุณาระบุ Project Type");
        }
        else if(typeId && (typeId.id === Utils.GENERATE_TYPE_MASTER_URL && showProjectMasterURL) && !projectId) {
            toast.error("กรุณาระบุ Project");
        }
        else if(!utmGroupId) {
            toast.error("กรุณาระบุ Group UTM");
        }
        else {

            let sourceTypeIdsCount = [];
            let sourceTypeIdsAll = [];
            let selectSourceTypeAll = 0;
            for(let item of utmGroupItem) {
                let selectSourceTypeIds = document.getElementsByName('sourceTypeIds[' + item.id + '][]');
                let sourceTypeIds = [];
                selectSourceTypeAll += selectSourceTypeIds.length;
                if(selectSourceTypeIds) {
                    for(let st of selectSourceTypeIds) {
                        if(st.value) {
                            let utmSourceTypeId = st.value;
                            let utmSourceId = 0;
                            let utmSourceTypeText = null;
                            let inputType = null;

                            if(utmSourceTypeId.includes(':CID')) {
                                let sp = utmSourceTypeId.split(':CID');
                                let contentId = sp[0];
                                utmSourceId = sp[1];
                                let contentView = await Utils.getContentIdView(contentId);
                                utmSourceTypeText = Utils.contentIdGenerater(contentView);
                                utmSourceTypeId = contentId;
                                inputType = Utils.API_TYPE_CONTENT_ID;
                            }
                            else if(utmSourceTypeId.includes(':OID')) {
                                let sp = utmSourceTypeId.split(':OID');
                                let ownerId = sp[0];
                                utmSourceId = sp[1];
                                let resOwner = await Utils.getOwnerView(ownerId);
                                let ownerCodeRow = await getOwnerRunningId(ownerId);
                                utmSourceTypeText = getOwnerRunningCode(resOwner.code, ownerCodeRow.code ?? 1);
                                utmSourceTypeId = ownerId;
                                inputType = Utils.API_TYPE_OWNER_ID;
                            }
                            else if(utmSourceTypeId.includes(':CP')) {
                                let sp = utmSourceTypeId.split(':CP');
                                let campaignId = sp[0];
                                utmSourceId = sp[1];
                                utmSourceTypeText = campaignId;
                                utmSourceTypeId = 0;
                                inputType = Utils.API_TYPE_CAMPAIGN_ID;
                            }
                            else if(utmSourceTypeId.includes(':CN')) {
                                let sp = utmSourceTypeId.split(':CN');
                                let campaignName = sp[0];
                                utmSourceId = sp[1];
                                utmSourceTypeText = campaignName;
                                utmSourceTypeId = 0;
                                inputType = Utils.API_TYPE_CAMPAIGN_NAME;
                            }
                            else if(utmSourceTypeId.includes(':PJI')) {
                                let sp = utmSourceTypeId.split(':PJI');
                                let projectCode = sp[0];
                                utmSourceId = sp[1];
                                utmSourceTypeText = projectCode;
                                utmSourceTypeId = 0;
                                inputType = Utils.API_TYPE_PROJECT_ID;
                            }
                            else if(utmSourceTypeId.includes(':PJN')) {
                                let sp = utmSourceTypeId.split(':PJN');
                                let projectName = sp[0];
                                utmSourceId = sp[1];
                                utmSourceTypeText = projectName;
                                utmSourceTypeId = 0;
                                inputType = Utils.API_TYPE_PROJECT_NAME;
                            }
                            else if(utmSourceTypeId.includes(':PJS')) {
                                let sp = utmSourceTypeId.split(':PJS');
                                let projectSlug = sp[0];
                                utmSourceId = sp[1];
                                utmSourceTypeText = projectSlug;
                                utmSourceTypeId = 0;
                                inputType = Utils.API_TYPE_PROJECT_SLUG;
                            }
                            else if(utmSourceTypeId.includes(':PMS')) {
                                let sp = utmSourceTypeId.split(':PMS');
                                let promotionSlug = sp[0];
                                utmSourceId = sp[1];
                                utmSourceTypeText = promotionSlug;
                                utmSourceTypeId = 0;
                                inputType = Utils.API_TYPE_PROMOTION_SLUG;
                            }
                            else if(utmSourceTypeId.includes(':LINEOA')) {
                                let sp = utmSourceTypeId.split(':LINEOA');
                                let lineOAUrl = sp[0];
                                utmSourceId = sp[1];
                                utmSourceTypeText = lineOAUrl;
                                utmSourceTypeId = 0;
                                inputType = Utils.API_TYPE_LINE_OAID;
                            }
                            else {
                                let sourceTypeRow = await Utils.getUtmSourceTypeById(utmSourceTypeId);
                                utmSourceId = sourceTypeRow.utmSourceId;
                                utmSourceTypeText = sourceTypeRow.name;
                            }

                            sourceTypeIds.push({
                                utmSourceId: utmSourceId,
                                utmSourceTypeId: utmSourceTypeId,
                                utmSourceTypeText: utmSourceTypeText,
                                inputType: inputType
                            });
                            sourceTypeIdsCount.push(sourceTypeIds);
                        }
                    }
                    sourceTypeIdsAll.push({
                        utmGroupItemId: item.id,
                        sourceTypeIds: sourceTypeIds
                    });
                }
            }
            if(sourceTypeIdsCount.length !== selectSourceTypeAll) {
                toast.error("กรุณาเลือก UTM ให้ครบถ้วน");
                return;
            }

            confirmAlert({
                title: 'แจ้งเตือน',
                message: 'ต้องการบันทึกข้อมูล ?',
                buttons: [
                    {
                        label: 'ตกลง',
                        onClick: async () => {
                            setLoading(true);

                            let rebrandlyUrlChecked = document.getElementsByName('rebrandlyUrlChecked');
                            let shortioUrlChecked = document.getElementsByName('shortioUrlChecked');

                            //Main URL
                            let url = refUrl.current.value;
                            if(masterUrlText) {
                                url = masterUrlText;
                            }
                            url = url.toString().trim();

                            let x = 1;
                            for(let rs of sourceTypeIdsAll) {
                                let utmGroupItemId = rs.utmGroupItemId;
                                let sourceTypeIds = rs.sourceTypeIds;
                                let sourceTypeIdsParam = [];
                                for(let row of sourceTypeIds) {
                                    let inputType = row.inputType;
                                    if(inputType === Utils.API_TYPE_CONTENT_ID) {
                                        sourceTypeIdsParam.push(row.utmSourceTypeId + ':CID' + row.utmSourceId);
                                    }
                                    else if(inputType === Utils.API_TYPE_OWNER_ID) {
                                        sourceTypeIdsParam.push(row.utmSourceTypeId + ':OID' + row.utmSourceId);
                                    }
                                    else if(inputType === Utils.API_TYPE_CAMPAIGN_ID) {
                                        sourceTypeIdsParam.push(campaignId.campaign_id + ':CP' + row.utmSourceId);
                                    }
                                    else if(inputType === Utils.API_TYPE_CAMPAIGN_NAME) {
                                        sourceTypeIdsParam.push(campaignId.campaign_name + ':CN' + row.utmSourceId);
                                    }
                                    else if(inputType === Utils.API_TYPE_PROJECT_ID) {
                                        sourceTypeIdsParam.push(projectId.project_code + ':PJI' + row.utmSourceId);
                                    }
                                    else if(inputType === Utils.API_TYPE_PROJECT_NAME) {
                                        sourceTypeIdsParam.push(projectId.new_project_name + ':PJN' + row.utmSourceId);
                                    }
                                    else if(inputType === Utils.API_TYPE_PROJECT_SLUG) {
                                        sourceTypeIdsParam.push(projectId.project_slug + ':PJS' + row.utmSourceId);
                                    }
                                    else if(inputType === Utils.API_TYPE_PROMOTION_SLUG) {
                                        sourceTypeIdsParam.push(promotionId.new_promotion_slug + ':PMS' + row.utmSourceId);
                                    }
                                    else if(inputType === Utils.API_TYPE_LINE_OAID) {
                                        sourceTypeIdsParam.push(row.utmSourceTypeText + ':LINEOA' + row.utmSourceId);
                                    }
                                    else {
                                        sourceTypeIdsParam.push(row.utmSourceTypeId);
                                    }
                                }

                                //Create Params
                                let params = await Utils.generateParams({
                                    langId: langId,
                                    typeId: typeId,
                                    campaignTypeId: campaignTypeId,
                                    buTypeId: buTypeId
                                }, sourceTypeIdsParam);
                                params = params + (hashtag ? '#' + hashtag.name:'');

                                let urlParam = url + '?' + params;

                                //Create Short URL (Rebrandly)
                                let rebrandlyUrl = null;
                                if(urlParam && rebrandlyUrlChecked.length && rebrandlyUrlChecked[0].checked)  {
                                    const resShortUrl = await Utils.getRebrandlyShortURL(rebrandly, urlParam);
                                    rebrandlyUrl = resShortUrl.shortUrl;
                                }

                                //Create Short URL (Short.IO)
                                let shortioUrl = null;
                                if(urlParam && shortioUrlChecked.length && shortioUrlChecked[0].checked)  {
                                    const resShortUrl = await Utils.createShortioShortURL(urlParam);
                                    shortioUrl = resShortUrl.path;
                                }

                                const body = {
                                    typeId: typeId ? typeId.id : null,
                                    lang: langId ? langId.id : null,
                                    projectTypeId: projectTypeId ? projectTypeId.id : null,
                                    projectId: projectId ? projectId.project_code : null,
                                    campaignDate: campaignDate ? new Date(campaignDate) : null,
                                    campaignId: campaignId ? campaignId.campaign_id : null,
                                    campaignTypeId: campaignTypeId ? campaignTypeId.id : null,
                                    buTypeId: buTypeId ? buTypeId.id : null,
                                    promotionId: promotionId ? promotionId.campaign_id : null,
                                    url: url,
                                    utmTemplateId: utmTemplateId ? utmTemplateId.id : null,
                                    utmGroupId: utmGroupId ? utmGroupId.id : null,
                                    utmGroupItemId: utmGroupItemId,
                                    hashtag: hashtag ? hashtag.name : null,
                                    params: params,
                                    shortUrl: rebrandlyUrl,
                                    shortioUrl: shortioUrl,
                                    masterUrlId: masterUrlId ? masterUrlId.id : null,
                                    createdBy: userId,
                                    createdAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
                                    updatedAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
                                    sourceTypeIds: sourceTypeIds
                                };

                                fetch(Config.url.API_URL +'/api/utmGenerate/create', {
                                    method: 'POST',
                                    body: JSON.stringify(body),
                                    headers: {
                                        'Content-Type':'application/json',
                                        'x-access-token': roles.accessToken
                                    }
                                }).then(response => {
                                    setLoading(false);
                                    if(response.ok) {
                                        return response.json();
                                    }
                                    else {
                                        return response.json().then(err => Promise.reject(err));
                                    }
                                }).then(result => {
                                    //isSuccess.push('x'+x);
                                    //console.log('x'+x);
                                    toast.success("บันทึกข้อมูลเรียบร้อย");
                                    x++;
                                }).catch(err => {
                                    toast.error(err.message);
                                })
                                //console.log('x : ' + x + ', isSuccess : ' + isSuccess + ', all : ' + sourceTypeIdsAll.length);
                                if(x === sourceTypeIdsAll.length) {
                                    setTimeout(function () {
                                        navigate('/utmGenerate', {replace: true});
                                    }, 1500);
                                }
                            }


                        }
                    },
                    {
                        label: 'ยกเลิก',
                        onClick: () => {}
                    }
                ]
            });
        }
    };

    const onChangeHashtag = (obj) => {
        setHashtag(obj);
    };

    const onChangeTypeId = async (obj) => {
        onReset();
        setTypeId(obj);

        if(obj && obj.id === Utils.GENERATE_TYPE_MASTER_URL) {
            setMasterUrlPlaceholder('กำลังโหลด...');
            setDisableMasterUrl(true);
            const resMasterURL = await Utils.getMasterUrl();
            setMasterUrl(resMasterURL);
            setMasterUrlPlaceholder('Select...');
            setDisableMasterUrl(false);
        }

        if(!obj) {
            setUtmGroupItem(null);
            setDisableGroup(true);
            setUtmGroup('');
            setUtmGroupItem(null);
        }

        //get campaign all
        if(obj && (obj.id === Utils.GENERATE_TYPE_SPECIAL || obj.id === Utils.GENERATE_TYPE_MASTER_URL)) {
            setCampaignPlaceholder('กำลังโหลด...');
            setDisableCampaign(true);
            const resCampaign = await Utils.getListSubCampaign();
            if(resCampaign) {
                let campaignList = resCampaign.campaign;
                if(campaignList) {
                    let newCampaign = [];
                    for(let rs of campaignList) {
                        newCampaign.push({
                            campaign_id: rs.sub_campaign_id,
                            campaign_name: rs.sub_campaign_name
                        })
                    }
                    setCampaign(newCampaign);
                    setCampaignPlaceholder('Select...');
                    setDisableCampaign(false);
                }
            }
            else {
                setCampaign(null);
                setCampaignPlaceholder('ไม่พบข้อมูล..');
            }
        }
    };

    const onChangeLanguageId = (obj) => {
        setLanguageId(obj);
        setProject('');
        setProjectId(null);
        setProjectPlaceholder('...');
        setDisableProject(true);

        setPromotion('');
        setPromotionId(null);
        setPromotionPlaceholder('...');
        setDisablePromotion(true);

        refUrl.current.value = '';
    };

    const onChangeProjectTypeId = (obj) => {
        setProjectTypeId(obj);
        setProject('');
        setProjectId(null);
        setProjectPlaceholder('...');
        setDisableProject(true);
        refUrl.current.value = '';
    };

    const onChangeProjectId = async (obj) => {
        setProjectId(obj);
        refUrl.current.value = obj && obj.project_url? obj.project_url : '';
        setCampaign(null);
        setCampaignId(null);
        setCampaignPlaceholder('...');
        setDisableCampaign(true);

        //reset UTM
        setUtmTemplateId(null);
        setUtmGroupId(null);
        setUtmGroupItemId(null);
        setUtmGroup(null);
        setUtmGroupItem(null);
        setDisableGroup(true);

        if(obj && obj.project_type_slug && obj.project_slug) {
            obj.new_project_name = await Utils.getProjectNameSlug({
                langId: langId.id,
                project_type_slug: obj.project_type_slug,
                project_slug: obj.project_slug
            });
        }
    };

    const onChangeProjectMasterURLId = async (obj) => {
        setProjectId(obj);
        await onChangeTemplateId(utmTemplateId);
    };

    const onChangePromotionId = async (obj) => {
        setPromotionId(obj);
        setProjectTypeId(null);
        setCampaignId(null);
        setUtmTemplateId(null);

        //reset UTM
        setUtmTemplateId(null);
        setUtmGroupId(null);
        setUtmGroupItemId(null);
        setUtmGroup(null);
        setUtmGroupItem(null);
        setDisableGroup(true);

        if(obj && obj.campaign_id) {
            setCampaignId({campaign_id: obj.campaign_id, campaign_name: obj.promotion_name});

            obj.new_promotion_slug = await Utils.getPromotionSlug({
                buTypeId: buTypeId.id,
                campaignTypeId: campaignTypeId.id,
                langId: langId.id,
                promotionSlug: obj.promotion_slug
            });
        }
        refUrl.current.value = obj && obj.promotion_url? obj.promotion_url : '';
    };

    const onChangeCampaignDate = (value) => {
        setCampaignDate(value);
        setCampaign(null);
        setCampaignId(null);
        setDisableCampaign(true);

        setPromotion('');
        setPromotionId(null);
        setPromotionPlaceholder('...');
        setDisablePromotion(true);
    };

    const onChangeCampaignTypeId = (obj) => {
        setCampaignTypeId(obj);
        setCampaign(null);
        setCampaignId(null);
        setDisableCampaign(true);

        setPromotion('');
        setPromotionId(null);
        setPromotionPlaceholder('...');
        setDisablePromotion(true);
    };

    const onChangeBuTypeId = (obj) => {
        setBuTypeId(obj);
        setCampaign(null);
        setCampaignId(null);
        setProjectTypeId(null);
        setDisableCampaign(true);

        setPromotion('');
        setPromotionId(null);
        setPromotionPlaceholder('...');
        setDisablePromotion(true);
    };

    const onChangeCampaignId = (obj) => {
        setCampaignId(obj);
        setUtmTemplateId(null);

        if(typeId && typeId.id === Utils.GENERATE_TYPE_SPECIAL) {
            setUtmTemplateId(null);
        }
    };

    const onChangeTemplateId = async (obj) => {
        setUtmTemplateId(obj);
        setUtmGroupId(null);
        setUtmGroupItemId(null);
        setUtmGroup(null);
        setUtmGroupItem(null);
        setDisableGroup(false);

        if(obj && obj.id) {
            const resGroup = await Utils.getGroupByTemplate(obj.id);
            setUtmGroup(resGroup);

            //check is template use project
            if(typeId && typeId.id === Utils.GENERATE_TYPE_MASTER_URL) {
                const resSource = await Utils.getTemplateSourceById(obj.id);
                for(let rs of resSource) {
                    if(rs.source.inputType === Utils.API_TYPE_PROJECT_SLUG
                        || rs.source.inputType === Utils.API_TYPE_PROJECT_ID
                        || rs.source.inputType === Utils.API_TYPE_PROJECT_NAME
                        || rs.source.inputType === Utils.API_TYPE_LINE_OAID
                    ) {
                        setShowProjectMasterURL(true);
                        break;
                    }
                }
            }
        }
    };

    const onChangeUtmGroupId = async (obj) => {
        setUtmGroupId(obj);
        setUtmGroupItem(null);
        setUtmGroupItemId(null);

        if(obj && obj.id) {
            const resSource = await Utils.getTemplateSourceById(obj.utmTemplateId);
            const resUtm = await Utils.getUtmByIds(resSource);
            const groupItems = await Utils.getGroupItemByGroup(obj.id);

            let chkCID = resSource.find(e => e.source.inputType === Utils.API_TYPE_CONTENT_ID);
            let resContentId = null;
            if(chkCID) {
                resContentId = await Utils.getContentId({agencyId: roles.agencyId});
            }

            let chkOID = resSource.find(e => e.source.inputType === Utils.API_TYPE_OWNER_ID);
            let resOwnerId = null;
            if(chkOID) {
                resOwnerId = await Utils.getOwner({agencyId: roles.agencyId});
            }

            //STEP 1: List Group Items
            if(groupItems) {
                let newGroupItem = [];
                for(let itemX of groupItems) {
                    let itemId = itemX.id;
                    const itemView = await Utils.getGroupItemView(itemId);
                    let itemSource = itemView.itemSource;
                    //STEP 2: Find UTM Group
                    if(resUtm) {
                        let newUtm = [];
                        for(let utmX of resUtm) {
                            //STEP 2: Find UTM Source
                            if(resSource) {
                                let ex = [];
                                let itx = [];
                                let selectedX = null;
                                for(let rx of resSource) {
                                    if(utmX.id === rx.utmId) {
                                        ex.push('{' + rx.source.name + '}');

                                        let sourceType = rx.source.sourceType;
                                        let inputType = rx.source.inputType;
                                        if(inputType === Utils.API_TYPE_CONTENT_ID) {
                                            selectedX = itemSource.find(it => {
                                                if(rx.source.inputType === it.inputType) {
                                                    return it;
                                                }
                                            });
                                            let newContentId = [];
                                            if(resContentId) {
                                                for(let row of resContentId) {
                                                    newContentId.push({
                                                        id: row.id + ':CID' + rx.source.id,
                                                        name: Utils.contentIdGenerater(row)
                                                    });
                                                }
                                                rx.source.sourceType = newContentId;
                                            }
                                        }
                                        else if(inputType === Utils.API_TYPE_OWNER_ID) {
                                            selectedX = itemSource.find(it => {
                                                if(rx.source.inputType === it.inputType) {
                                                    return it;
                                                }
                                            });
                                            let newOwnerId = [];
                                            if(resOwnerId) {
                                                for(let row of resOwnerId) {
                                                    newOwnerId.push({
                                                        id: row.id + ':OID' + rx.source.id,
                                                        name: row.code.charAt(0) + ' : ' + row.name
                                                    });
                                                }
                                                rx.source.sourceType = newOwnerId;
                                            }
                                        }
                                        else if(sourceType && !inputType) {
                                            selectedX = sourceType.find(so => {
                                                return itemSource.find(it => {
                                                    if(so.id === it.utmSourceTypeId) {
                                                        return so;
                                                    }
                                                });
                                            });
                                        }
                                        else {
                                            selectedX = null;
                                        }
                                        rx.selectedX = selectedX;
                                        itx.push(rx);
                                    }
                                }
                                utmX.example = ex.join('_');
                                utmX.item = itx;
                            }
                            newUtm.push(utmX);
                        }

                        itemView.utm = newUtm;
                        itemView.preview = await previewUTM(itemView);
                        newGroupItem.push(itemView);
                    }
                }
                setUtmGroupItem(newGroupItem);
            }
        }
    };

    const onChangeMasterURLId = (obj) => {
        setMasterUrlId(null);
        refUrl.current.value = '';
        if(obj) {
            setMasterUrlId(obj);
            setMasterUrlText(obj.url);
        }
    };

    const onReset = () => {
        setLanguageId(null);
        setCampaignDate(null);
        setTypeId(null);
        setProjectTypeId(null);
        setProjectId(null);
        setCampaignId(null);
        setCampaignTypeId(null);
        setBuTypeId(null);
        setPromotionId(null);
        setUtmTemplateId(null);
        setUtmGroupId(null);
        setUtmGroupItemId(null);

        refUrl.current.value = '';

        setDisableProject(true);
        setDisablePromotion(true);
        setDisableCampaign(true);
        setProjectPlaceholder('...');
        setPromotionPlaceholder('...');
        setCampaignPlaceholder('...');

        setMasterUrl(null);
        setMasterUrlId(null);
        setMasterUrlText(null);
    };

    const onChangeUtmItem = async (obj, index, inputType) => {
        await onChangeUtmGroupId(utmGroupId);
    };

    const previewUTM = async (itemView) => {
        let sourceTypeIdsParam = [];
        if(itemView) {
            for(let utm of itemView.utm) {
                for(let item of utm.item) {
                    let selectedX = item.selectedX;
                    let source = item.source;
                    let inputType = source.inputType;
                    if(inputType === Utils.API_TYPE_CONTENT_ID) {
                        if(selectedX && selectedX.utmSourceTypeId) {
                            sourceTypeIdsParam.push(selectedX.utmSourceTypeId + ':CID' + selectedX.utmSourceId);
                        }
                    }
                    else if(inputType === Utils.API_TYPE_OWNER_ID) {
                        if(selectedX && selectedX.utmSourceTypeId) {
                            sourceTypeIdsParam.push(selectedX.utmSourceTypeId + ':OID' + selectedX.utmSourceId);
                        }
                    }
                    else if(inputType === Utils.API_TYPE_CAMPAIGN_ID) {
                        sourceTypeIdsParam.push(campaignId.campaign_id + ':CP' + source.id);
                    }
                    else if(inputType === Utils.API_TYPE_CAMPAIGN_NAME) {
                        sourceTypeIdsParam.push(campaignId.campaign_name + ':CN' + source.id);
                    }
                    else if(inputType === Utils.API_TYPE_PROJECT_ID) {
                        sourceTypeIdsParam.push(projectId.project_code + ':PJI' + source.id);
                    }
                    else if(inputType === Utils.API_TYPE_PROJECT_NAME) {
                        sourceTypeIdsParam.push(projectId.new_project_name + ':PJN' + source.id);
                    }
                    else if(inputType === Utils.API_TYPE_PROJECT_SLUG) {
                        sourceTypeIdsParam.push(projectId.project_slug + ':PJS' + source.id);
                    }
                    else if(inputType === Utils.API_TYPE_PROMOTION_SLUG) {
                        sourceTypeIdsParam.push(promotionId.new_promotion_slug + ':PMS' + source.id);
                    }
                    else if(inputType === Utils.API_TYPE_LINE_OAID) {
                        sourceTypeIdsParam.push(projectId.line_oaid + ':LINEOA' + source.id);
                    }
                    else {
                        sourceTypeIdsParam.push(selectedX?.id);
                    }
                }
            }

            let params = await Utils.generateParams({
                langId: langId,
                typeId: typeId,
                campaignTypeId: campaignTypeId,
                buTypeId: buTypeId
            }, sourceTypeIdsParam);

            let url = refUrl ? refUrl.current.value : '';
            if(masterUrlText) {
                url = masterUrlText;
            }

            return (url ? url.toString().trim() + '?':'') + params + (hashtag ? '#' + hashtag.name:'');
        }
    };

    return (
        <main>
            <div className="row table-toolbar mb-2">
                <div className="col-6 align-self-center">
                    <div className="h6 d-inline"><span className="text-success">&#8226;</span> Generate UTM</div>
                    <span className="ms-1">/</span> <span className="text-muted">Create</span>
                </div>
                <div className="col-6 text-end align-self-center toolbars">
                </div>
            </div>
            <div className="rounded bg-white p-4 shadow">
                <div className="row">
                    <div className="col-12 col-md-8">
                        <form className="row g-3">
                            <div className="col-12">
                                <label htmlFor="typeIed" className="form-label">Type <span className="text-danger">*</span></label>
                                <Select
                                    isClearable={true}
                                    classNamePrefix="form-select-search"
                                    options={type}
                                    onChange={(event) => onChangeTypeId(event)}
                                    value={typeId}
                                    getOptionValue={(option) => `${option.id}`}
                                    getOptionLabel={(option) => `${option.name}`}
                                />
                            </div>
                            <div className={typeId && (typeId.id === Utils.GENERATE_TYPE_MASTER_URL) ? 'col-12':'d-none'}>
                                <label htmlFor="masterURLId" className="form-label">Master URL <span className="text-danger">*</span></label>
                                <Select
                                    isClearable={true}
                                    isDisabled={disableMasterUrl}
                                    placeholder={masterUrlPlaceholder}
                                    classNamePrefix="form-select-search"
                                    options={masterUrl}
                                    onChange={(event) => onChangeMasterURLId(event)}
                                    value={masterUrlId}
                                    getOptionValue={(option) => `${option.id}`}
                                    getOptionLabel={(option) => `${option.id} : ${option.name}`}
                                />
                            </div>

                            {
                                typeId && (typeId.id === Utils.GENERATE_TYPE_PROJECT || typeId.id === Utils.GENERATE_TYPE_PROMOTION) ?
                                    <div className="col-12">
                                        <label htmlFor="langId" className="form-label">Language <span className="text-danger">*</span></label>
                                        <Select
                                            isClearable={true}
                                            classNamePrefix="form-select-search"
                                            options={lang}
                                            onChange={(event) => onChangeLanguageId(event)}
                                            value={langId}
                                            getOptionValue={(option) => `${option.id}`}
                                            getOptionLabel={(option) => `${option.name}`}
                                        />
                                    </div> : ''
                            }
                            {
                                typeId && (typeId.id === Utils.GENERATE_TYPE_PROJECT) ?
                                    <>
                                        <div className="col-12">
                                            <label htmlFor="projectTypeId" className="form-label">Project Type <span className="text-danger">*</span></label>
                                            <Select
                                                isClearable={true}
                                                classNamePrefix="form-select-search"
                                                options={projectType}
                                                onChange={(event) => onChangeProjectTypeId(event)}
                                                value={projectTypeId}
                                                getOptionValue={(option) => `${option.id}`}
                                                getOptionLabel={(option) => `${option.name}`}
                                            />
                                        </div>
                                        <div className="col-12">
                                            <label htmlFor="projectId" className="form-label">Project <span className="text-danger">*</span></label>
                                            <Select
                                                isClearable={true}
                                                isDisabled={disableProject}
                                                classNamePrefix="form-select-search"
                                                placeholder={projectPlaceholder}
                                                options={project}
                                                onChange={(event) => onChangeProjectId(event)}
                                                value={projectId}
                                                getOptionValue={(option) => `${option.project_code}`}
                                                getOptionLabel={(option) => `${option.project_code} : ${option.project_title}`}
                                            />
                                        </div>
                                    </> : ''
                            }

                            <div className={typeId && (typeId.id === Utils.GENERATE_TYPE_PROMOTION) ? 'col-12':'d-none'}>
                                <label htmlFor="campaignTypeId" className="form-label">Campaign Type <span className="text-danger">*</span></label>
                                <Select
                                    isClearable={true}
                                    classNamePrefix="form-select-search"
                                    options={campaignType}
                                    onChange={(event) => onChangeCampaignTypeId(event)}
                                    value={campaignTypeId}
                                    getOptionValue={(option) => `${option.id}`}
                                    getOptionLabel={(option) => `${option.name}`}
                                />
                            </div>
                            <div className={typeId && (typeId.id === Utils.GENERATE_TYPE_PROMOTION) ? 'col-12':'d-none'}>
                                <label htmlFor="buTypeId" className="form-label">BU Type <span className="text-danger">*</span></label>
                                <Select
                                    isClearable={true}
                                    classNamePrefix="form-select-search"
                                    options={buType}
                                    onChange={(event) => onChangeBuTypeId(event)}
                                    value={buTypeId}
                                    getOptionValue={(option) => `${option.id}`}
                                    getOptionLabel={(option) => `${option.name}`}
                                />
                            </div>
                            <div className={typeId && (typeId.id === Utils.GENERATE_TYPE_PROJECT || typeId.id === Utils.GENERATE_TYPE_PROMOTION) ? 'col-12':'d-none'}>
                                <label htmlFor="campaignDate" className="form-label">Campaign Date <span className="text-danger d-none">*</span></label>
                                <DatePicker
                                    selected={campaignDate}
                                    onChange={(date) => onChangeCampaignDate(date)}
                                    dateFormat="yyyy-MM-dd"
                                    wrapperClassName="w-100"
                                    className="form-control w-100" />
                            </div>
                            <div className={typeId && (typeId.id === Utils.GENERATE_TYPE_PROJECT || typeId.id === Utils.GENERATE_TYPE_SPECIAL || typeId.id === Utils.GENERATE_TYPE_MASTER_URL) ? 'col-12':'d-none'}>
                                <label htmlFor="campaignId" className="form-label">Campaign ID <span className="text-danger">*</span></label>
                                <Select
                                    isClearable={true}
                                    isDisabled={disableCampaign}
                                    classNamePrefix="form-select-search"
                                    placeholder={campaignPlaceholder}
                                    options={campaign}
                                    onChange={(event) => onChangeCampaignId(event)}
                                    value={campaignId}
                                    getOptionValue={(option) => `${option.campaign_id}`}
                                    getOptionLabel={(option) => `${option.campaign_id} : ${option.campaign_name}`}
                                />
                            </div>
                            <div className={typeId && (typeId.id === Utils.GENERATE_TYPE_PROMOTION) ? 'col-12':'d-none'}>
                                <label htmlFor="promotionId" className="form-label">Promotion ID <span className="text-danger">*</span></label>
                                <Select
                                    isClearable={true}
                                    classNamePrefix="form-select-search"
                                    isDisabled={disablePromotion}
                                    placeholder={promotionPlaceholder}
                                    options={promotion}
                                    onChange={(event) => onChangePromotionId(event)}
                                    value={promotionId}
                                    getOptionValue={(option) => `${option.promotion_url}`}
                                    getOptionLabel={(option) => `${option.campaign_id} : ${option.promotion_name} : ${option.project_type_slug}`}
                                />
                            </div>
                            <div className={"col-12 mt-4" + (typeId && typeId.id === Utils.GENERATE_TYPE_MASTER_URL ? ' d-none' : '')}>
                                <div className="border rounded bg-green-light p-2">
                                    <div className="row">
                                        <div className="col-12">
                                            <label htmlFor="url" className="form-label">URL <span className="text-danger">*</span></label>
                                            <textarea className="form-control" id="url" ref={refUrl} rows={5}></textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-12">
                                <label htmlFor="template" className="form-label">Template <span className="text-danger">*</span></label>
                                <Select
                                    isClearable={true}
                                    isDisabled={!typeId || (typeId.id === Utils.GENERATE_TYPE_PROJECT && (!langId || !projectTypeId || !projectId || !campaignId)) || (typeId.id === Utils.GENERATE_TYPE_PROMOTION && (!langId || !campaignTypeId || !buTypeId || !promotionId))}
                                    classNamePrefix="form-select-search"
                                    options={utmTemplate}
                                    onChange={(event) => onChangeTemplateId(event)}
                                    value={utmTemplateId}
                                    getOptionValue={(option) => `${option.id}`}
                                    getOptionLabel={(option) => `${option.name}`}
                                />
                            </div>

                            {// check is line oa
                                typeId && typeId.id === Utils.GENERATE_TYPE_MASTER_URL && showProjectMasterURL ?
                                    <>
                                        <div className="col-12">
                                            <label htmlFor="langId" className="form-label">Language <span className="text-danger">*</span></label>
                                            <Select
                                                isClearable={true}
                                                classNamePrefix="form-select-search"
                                                options={lang}
                                                onChange={(event) => onChangeLanguageId(event)}
                                                value={langId}
                                                getOptionValue={(option) => `${option.id}`}
                                                getOptionLabel={(option) => `${option.name}`}
                                            />
                                        </div>
                                        <div className="col-12">
                                            <label htmlFor="projectTypeId" className="form-label">Project Type <span className="text-danger">*</span></label>
                                            <Select
                                                isClearable={true}
                                                classNamePrefix="form-select-search"
                                                options={projectType}
                                                onChange={(event) => onChangeProjectTypeId(event)}
                                                value={projectTypeId}
                                                getOptionValue={(option) => `${option.id}`}
                                                getOptionLabel={(option) => `${option.name}`}
                                            />
                                        </div>
                                        <div className="col-12">
                                            <label htmlFor="projectId" className="form-label">Project <span className="text-danger">*</span></label>
                                            <Select
                                                isClearable={true}
                                                isDisabled={disableProjectMasterURL}
                                                classNamePrefix="form-select-search"
                                                placeholder={projectMasterURLPlaceholder}
                                                options={projectMasterURL}
                                                onChange={(event) => onChangeProjectMasterURLId(event)}
                                                value={projectId}
                                                getOptionValue={(option) => `${option.project_code}`}
                                                getOptionLabel={(option) => `${option.project_code} : ${option.project_title}`}
                                            />
                                        </div>
                                    </> : ''
                            }

                            <div className="col-12">
                                <label htmlFor="group" className="form-label">Group UTM <span className="text-danger">*</span></label>
                                <Select
                                    isClearable={true}
                                    isDisabled={disableGroup || !utmTemplateId}
                                    classNamePrefix="form-select-search"
                                    options={utmGroup}
                                    onChange={(event) => onChangeUtmGroupId(event)}
                                    value={utmGroupId}
                                    getOptionValue={(option) => `${option.id}`}
                                    getOptionLabel={(option) => `${option.name}`}
                                />
                            </div>

                            {/* ---- UTM */}
                            <div className={"col-12 " + (utmTemplateId === null ? 'd-none' : '')}>
                                {
                                    utmGroupItem ?
                                        utmGroupItem.map((item, idx) => {
                                            let itemId = item.id;
                                            let utmList = item.utm;
                                            let itemSource = item.itemSource;
                                            return (
                                                <div key={idx} className="bg-light shadow p-2 mb-4">
                                                    <div className="row">
                                                        <div className="fw-bold">{item.name}</div>
                                                        <div className="col-12">
                                                            {
                                                                utmList ? utmList.map((utm, index) => {
                                                                    let item = utm.item;
                                                                    return (<div key={index} className="border rounded bg-yellow-light p-2 mb-3">
                                                                            <div className="d-block fw-bold">{(utm.utmPrefix === 1 ? 'utm_':'') + utm.name.toLowerCase()}
                                                                                <span className="text-danger">*</span>
                                                                            </div>
                                                                            <div className="d-block mb-1 small">{utm.example}</div>
                                                                            {
                                                                                item ? item.map((rs, index) => {
                                                                                    let isClearable = false;
                                                                                    let selected = null;
                                                                                    let inputType = rs.source.inputType;
                                                                                    let sourceType = rs.source.sourceType;

                                                                                    if (inputType === Utils.API_TYPE_CONTENT_ID) {
                                                                                        //console.log(sourceType);
                                                                                    }
                                                                                    else if (inputType === Utils.API_TYPE_OWNER_ID) {
                                                                                        //console.log(sourceType);
                                                                                    }
                                                                                    else if (inputType === Utils.API_TYPE_CAMPAIGN_ID) {
                                                                                        if (campaignId) {
                                                                                            selected = {
                                                                                                id: campaignId.campaign_id + ':CP' + rs.source.id,
                                                                                                name: campaignId.campaign_id
                                                                                            };
                                                                                        }
                                                                                    }
                                                                                    else if (inputType === Utils.API_TYPE_CAMPAIGN_NAME) {
                                                                                        if (campaignId) {
                                                                                            selected = {
                                                                                                id: campaignId.campaign_name + ':CN' + rs.source.id,
                                                                                                name: campaignId.campaign_name
                                                                                            };
                                                                                        }
                                                                                    } else if (inputType === Utils.API_TYPE_PROJECT_ID) {
                                                                                        if (projectId) {
                                                                                            selected = {
                                                                                                id: projectId.project_code + ':PJI' + rs.source.id,
                                                                                                name: projectId.project_code
                                                                                            };
                                                                                        }
                                                                                    }
                                                                                    else if (inputType === Utils.API_TYPE_PROJECT_NAME) {
                                                                                        if (projectId) {
                                                                                            selected = {
                                                                                                id: projectId.new_project_name + ':PJN' + rs.source.id,
                                                                                                name: projectId.new_project_name
                                                                                            };
                                                                                        }
                                                                                    }
                                                                                    else if (inputType === Utils.API_TYPE_PROJECT_SLUG) {
                                                                                        if (projectId) {
                                                                                            selected = {
                                                                                                id: projectId.project_slug + ':PJS' + rs.source.id,
                                                                                                name: projectId.project_slug
                                                                                            };
                                                                                        }
                                                                                    }
                                                                                    else if (inputType === Utils.API_TYPE_PROMOTION_SLUG) {
                                                                                        if (promotionId && promotionId.new_promotion_slug) {
                                                                                            selected = {
                                                                                                id: promotionId.new_promotion_slug + ':PMS' + rs.source.id,
                                                                                                name: promotionId.new_promotion_slug
                                                                                            };
                                                                                        }
                                                                                    }
                                                                                    else if(inputType === Utils.API_TYPE_LINE_OAID) {
                                                                                        if(projectId) {
                                                                                            selected = {
                                                                                                id: projectId.line_oaid + ':LINEOA' + rs.source.id,
                                                                                                name: projectId.project_title
                                                                                            };
                                                                                        }
                                                                                    }
                                                                                    else {
                                                                                        selected = sourceType.find(so => {
                                                                                            return itemSource.find(it => {
                                                                                                if(so.id === it.utmSourceTypeId) {
                                                                                                    return so;
                                                                                                }
                                                                                            });
                                                                                        });
                                                                                    }

                                                                                    let sourceTypeIds = 'sourceTypeIds[' + itemId + '][]';

                                                                                    return (
                                                                                        <div key={index} className="ms-2 mt-3">
                                                                                            <div className="row mt-2">
                                                                                                <div className="col-12 col-sm-4 text-end small">
                                                                                                    {rs.source.name} :
                                                                                                    {userAgency?.isEncrypt === 1 && rs.source.isEncrypt ? <div><span className="badge bg-secondary small">encrypt</span></div>:''}
                                                                                                </div>
                                                                                                <div className="col-12 col-sm-8">
                                                                                                    <span className="text-muted small fw-light">{
                                                                                                        inputType === Utils.API_TYPE_PROJECT_NAME ?
                                                                                                            '{lang}-{project_type_slug}-{project_slug}' : ''
                                                                                                    }</span>
                                                                                                    <Select
                                                                                                        isClearable={isClearable}
                                                                                                        isSearchable={isClearable}
                                                                                                        name={sourceTypeIds}
                                                                                                        classNamePrefix="form-select-search"
                                                                                                        placeholder={selected ? 'Select...' : '...'}
                                                                                                        defaultValue={selected}
                                                                                                        options={selected ? [selected] : sourceType}
                                                                                                        getOptionValue={(option) => `${option.id}`}
                                                                                                        getOptionLabel={(option) => `${option.name}`}
                                                                                                        //onChange={(event) => onChangeUtmItem(event, index, inputType)}
                                                                                                    />
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    );
                                                                                }) : ''
                                                                            }
                                                                        </div>);
                                                                }) : ''
                                                            }
                                                        </div>

                                                        <div className="col-12">
                                                            <div className="small d-block">Preview</div>
                                                            <div className="noselect-url w100 rounded">{item.preview}</div>
                                                        </div>
                                                    </div>
                                                </div>);
                                        }) : ''
                                }
                            </div>

                            <div className="col-12">
                                <label htmlFor="typeIed" className="form-label">Hashtag (#)</label>
                                <Select
                                    isClearable={true}
                                    classNamePrefix="form-select-search"
                                    options={hashtagList}
                                    onChange={(event) => onChangeHashtag(event)}
                                    value={hashtag}
                                    getOptionValue={(option) => `${option.name}`}
                                    getOptionLabel={(option) => `${option.name}`}
                                />
                            </div>

                            <div className={"col-12" + (roles.isShortLink(Utils.MENU_UTM_GENERATE) && rebrandly && rebrandly.status===1 && rebrandly.apiKey && rebrandly.endpoint ? '':' d-none')}>
                                <label htmlFor="rebrandlyUrlx" className="form-label">Create Short URL (Rebrandly)</label>
                                <div className="form-check form-switch">
                                    <input className="form-check-input" type="checkbox" name="rebrandlyUrlChecked" id="rebrandlyUrl" defaultChecked={false} />
                                    <label className="form-check-label" htmlFor="rebrandlyUrl"></label>
                                </div>
                            </div>

                            <div className={"col-12" + (roles.isShortLink(Utils.MENU_UTM_GENERATE) && shortio && shortio.status===1 && shortio.apiKey && shortio.endpoint ? '':' d-none')}>
                                <label htmlFor="shortioUrlx" className="form-label">Create Short URL (Short.IO)</label>
                                <div className="form-check form-switch">
                                    <input className="form-check-input" type="checkbox" name="shortioUrlChecked" id="shortioUrl" defaultChecked={false} />
                                    <label className="form-check-label" htmlFor="shortioUrl"></label>
                                </div>
                            </div>

                            <div className="col-12">
                                <button type="button" className="btn btn-primary" onClick={onCreate}><span
                                    className={isLoading ? 'spinner-grow spinner-grow-sm' : 'd-none'}></span> {isLoading ? btnTextLoading : btnTextDefault}</button>
                                <NavLink className="btn btn-sm btn-light ms-2" to='/utmGenerate'><span><Icon.ArrowLeft/> กลับไป</span></NavLink>
                                <Toaster position="bottom-right" />
                            </div>
                        </form>
                    </div>
                    <div className="col-12 col-md-6"></div>
                </div>
            </div>
        </main>
    );
} 